import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";

export class leanPlanningViewCtrl implements IController {

  segments: any;
  from: any;
  to: any;
  considerArea: any;
  considerTimeWindows: any;
  onlyInStore: any;
  serviceAreaIds: any;
  maxDeliveries: any;
  onlyUnRouted: any;
  openProcessIds: any;
  branchId?: any;
  disableBranch?: any;

  public loading: boolean = false;
  public progress: any = undefined;
  public selectedSegmentIds: any = [];
  public totals: any = {
    serviceAreas: null,
    totalDeliveries: null,
    minDeliveriesInArea: null,
    maxDeliveriesInArea: null
  };
  public configTimeZone: any = undefined;
  public today: any = undefined;
  public filtersConfig: any;

  constructor(private $log, private leanPlanningDialogService: LeanPlanningDialogService, private leanPlanningAlertsService: LeanPlanningAlertsService, private commonsAlertsService: CommonsAlertsService,
              private confirmChangeStateService: ConfirmChangeStateService, private deliveriesRequestsService: DeliveriesRequestsService, private $state, private serviceAreaRequests: ServiceAreaRequests, private moment, private splitService) {
  }

  $onInit() {
    this.configTimeZone = this.splitService.getTimeZone();
    this.today = this.moment().startOf('day');

    // Sets the transition from this component as confirm prompt
    this.confirmChangeStateService.setIsEnabled(true);

    this.filtersConfig = {
      date: this.moment(this.from),
      dateInTimeStamp: this.from,
      timeWindow: undefined,
      serviceAreaIds: this.serviceAreaIds,
      queryString: '',
      branchIds: this.branchId ? [this.branchId] : [],
      routingSettings: {
        maxDeliveries: this.maxDeliveries,
        considerTimeWindow: this.considerTimeWindows,
        considerArea: this.considerArea,
        onlyInStore: this.onlyInStore,
        onlyUnRouted: this.onlyUnRouted
      }
    };

    this._initTotals();

    if (this.openProcessIds.length) {
      this._openGeneratingDialog(this.openProcessIds, false); // Boolean for redirecting.
    }

  };

  onDateChange(selectedDate) {
    this.filtersConfig.date = this.moment(selectedDate).local().startOf('day').toISOString();
    this.filtersConfig.dateInTimeStamp = this.splitService.getStartDayTimestamp(selectedDate);
  }

  onTimeWindowChange(timeWindow) {
    this.filtersConfig.timeWindow = timeWindow;
    if (timeWindow) {
      this._reSetStateParams();
      this._getAndSetAnalysis();
    } else {
      this.segments = [];
      this.selectedSegmentIds = [];
    }
  }

  onBranchSelect(branchId) {
    if (!!branchId && !_.includes(this.filtersConfig.branchIds, branchId)) {
      this.branchId = branchId;
      this.filtersConfig.branchIds = [branchId];
      this.loading = true;

      this.deliveriesRequestsService.getAnalysisConfiguration(branchId)
        .then((configuration) => {
          this.filtersConfig.timeWindow = undefined;
          this.filtersConfig.routingSettings = {
            maxDeliveries: configuration.numberOfServicePerRoute,
            considerTimeWindow: configuration.considerTimeWindows,
            considerArea: configuration.considerServiceArea,
            onlyInStore: configuration.onlyInStore,
            onlyUnRouted: configuration.onlyUnRouted
          };
          return this.serviceAreaRequests.getAll(branchId ? {branchIds: [branchId]} : {})
        })
        .then((serviceAreas) => {
          this.filtersConfig.serviceAreaIds = _.map(serviceAreas, (area) => {
            return area.areaId;
          });
        })
        .catch((error) => {
          this.$log.info('Failed to get analysis configuration for branch @leanPlanningView@onBranchSelect', error);
          this.commonsAlertsService.somethingWentWrongError();
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  onAddAgents(segmentIndex, agent) {
    if (!agent) {
      agent = this._getEmptyDriver();
    }
    this.segments[segmentIndex].assignmentList.push(agent);
    // _initTotals();
  }


  onChangeAgent(segmentIndex, assignedAgentIndex, agent) {
    if (!agent) {
      agent = this._getEmptyDriver();
    }
    this.segments[segmentIndex].assignmentList[assignedAgentIndex] = agent;
    // _initTotals();
  }


  onRemoveAgent(segmentIndex, agentIndex) {
    this.segments[segmentIndex].assignmentList.splice(agentIndex, 1);
    // _initTotals();
  }


  onEditRoutingSettings(event) {
    this.leanPlanningDialogService.routingSettings(event, this.filtersConfig.routingSettings).then(
      (updatedSettings) => {
        this.filtersConfig.routingSettings = updatedSettings;
        this._reSetStateParams();
        this._getAndSetAnalysis();
      },
      () => {
        this.$log.info('Closed Dialog')
      }
    )
  }


  onChangeServiceAreas(serviceAreaIds) {
    if (!_.isEqual(this.filtersConfig.serviceAreaIds, serviceAreaIds)) {
      this.filtersConfig.serviceAreaIds = serviceAreaIds;
      this._reSetStateParams();
      this._getAndSetAnalysis();
    }
  }


  onCreateRoutes(doAssign) {
    const segments = angular.copy(this.segments);
    _.forEach(segments, (segment) => {
      _.forEach(segment.assignmentList, (assignedAgent) => {
        if (_.isUndefined(assignedAgent.maxNumberOfItems)) {
          _.set(assignedAgent, 'maxNumberOfItems', null)
        }
      });
      _.unset(segment, 'plannedServiceCounter');
    });
    this.loading = true;
    this.deliveriesRequestsService.createRoutes(segments, doAssign, this.filtersConfig.routingSettings.considerTimeWindow, this.filtersConfig.branchIds[0])
      .then((progress) => {
        if (!!progress) {
          this._openGeneratingDialog([progress.id], true);
        } else {
          this.$log.debug('Missing progressId');
        }
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to create routes @leanPlanningView@onCreateRoutes', error);
          this.commonsAlertsService.somethingWentWrongError();
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  onToggleSelectedSegment(segment) {
    const index = _.indexOf(this.selectedSegmentIds, segment.id);
    if (index !== -1) {
      this.selectedSegmentIds.splice(index, 1);
    } else {
      this.selectedSegmentIds.push(segment.id);
    }
    this.selectedSegmentIds = this.selectedSegmentIds.concat([]);
  }


  onMarge() {
    const segments = this._getSegmentsForServer();
    this.loading = true;
    this.deliveriesRequestsService.mergeAnalysis(
      segments,
      this.selectedSegmentIds,
      this.filtersConfig.routingSettings.maxDeliveries,
      this.filtersConfig.branchIds[0])
      .then((updatedSegments) => {
        this.leanPlanningAlertsService.mergeSegmentsSuccess();
        this.segments = updatedSegments;
        this.selectedSegmentIds = [];
        this._initTotals();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.mergeSegmentsError();
          this.$log.error('Failed to merge segments, @leanPlanningView@onMerge', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  onSplit() {
    const segments = this._getSegmentsForServer();
    this.loading = true;
    this.deliveriesRequestsService.splitAnalysis(
      segments,
      this.selectedSegmentIds,
      this.filtersConfig.routingSettings.maxDeliveries,
      this.filtersConfig.branchIds[0])
      .then((updatedSegments) => {
        this.leanPlanningAlertsService.splitSegmentsSuccess();
        this.segments = updatedSegments;
        this.selectedSegmentIds = [];
        this._initTotals();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.splitSegmentsError();
          this.$log.error('Failed to split segments @leanPlanningView@onSplit', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  getCreateButtonDisability() {
    return this.loading || !this.segments.length ? true : !this._doesAllRoutesHasDrivers()
  }

  // ******************************
  //        Internal methods
  // ******************************


  private _openGeneratingDialog(openProcessIds, doRedirectOnFinish) {
    this.leanPlanningDialogService.generatingRoutesDialog(openProcessIds)
      .then((createdRouteIds) => {
        //Generating Finished
        this.leanPlanningAlertsService.createManySuccess();
        if (doRedirectOnFinish) {

          // Reset transition confirmation prompt
          this.confirmChangeStateService.reset();

          if (this.branchId) {
            this._redirectToBranchRoutes(createdRouteIds);
          } else {
            this._redirectToRoutes(createdRouteIds);
          }
        }
      })
      .catch((progress) => {
        //Generating Canceled or Failed
        if (_.get(progress, 'hasFailed')) {
          this.leanPlanningAlertsService.createManyError();
        } else {
          this.leanPlanningAlertsService.cancelGeneratingRoutesSuccess();
        }
      })
      .finally(() => {
        // this.openProcesses = [];
      })
  }


  private _initTotals() {
    const maxMinDeliveries = this._getMinMaxDeliveries();

    this.totals = {
      serviceAreas: this._getTotalServiceAreas(),
      totalDeliveries: this._getTotalDeliveries(),
      maxDeliveriesInArea: maxMinDeliveries.max,
      minDeliveriesInArea: maxMinDeliveries.min,
      numberOfSegments: this._getTotalRoutes()
    };
  }


  private _getTotalDeliveries() {
    let deliveriesSum = 0;
    _.forEach(this.segments, (segment) => {
      deliveriesSum += segment.serviceIdList.length
    });
    return deliveriesSum;
  }


  private _getTotalServiceAreas() {
    let areasSum = 0;
    _.forEach(this.segments, (segment) => {
      if (segment.serviceIdList.length) {
        areasSum++
      }
    });
    return areasSum;
  }


  _getTotalRoutes() {
    var counter = 0;
    _.forEach(this.segments, (segment) => {
      counter += _.get(segment, 'assignmentList.length', 0);
    });
    return counter
  }

  _getMinMaxDeliveries() {
    const minMaxDeliveries = {
      max: {
        areaName: null,
        count: null
      },
      min: {
        areaName: null,
        count: null
      }
    };
    _.forEach(this.segments, (segment) => {
      const serviceAreaLength = segment.serviceIdList.length;
      if (!minMaxDeliveries.max.count || serviceAreaLength >= minMaxDeliveries.max.count) {
        minMaxDeliveries.max = {
          areaName: segment.name,
          count: serviceAreaLength
        }
      }
      if (serviceAreaLength && (!minMaxDeliveries.min.count || serviceAreaLength <= minMaxDeliveries.min.count)) {
        minMaxDeliveries.min = {
          areaName: segment.name,
          count: serviceAreaLength
        }
      }
    });

    return minMaxDeliveries;
  }


  private _getAndSetAnalysis() {
    var fromTo = this._getFromTo();
    this.loading = true;
    this.deliveriesRequestsService.getAnalysis(
      fromTo.from,
      fromTo.to,
      this.filtersConfig.serviceAreaIds,
      this.filtersConfig.routingSettings.considerArea,
      this.filtersConfig.routingSettings.considerTimeWindow,
      this.filtersConfig.routingSettings.onlyInStore,
      this.filtersConfig.routingSettings.maxDeliveries,
      this.filtersConfig.routingSettings.onlyUnRouted,
      this.filtersConfig.branchIds
    )
      .then((segments) => {
        this.segments = segments;
        this.selectedSegmentIds = [];
        this._initTotals();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to get segments', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }


  private _reSetStateParams() {
    const fromTo = this._getFromTo();
    this.$state.go('.',
      {
        from: fromTo.from,
        to: fromTo.to,
        areaIds: this.filtersConfig.serviceAreaIds,
        maxDeliveries: this.filtersConfig.routingSettings.maxDeliveries,
        considerArea: this.filtersConfig.routingSettings.considerArea,
        considerTimeWindows: this.filtersConfig.routingSettings.considerTimeWindow,
        onlyInStore: this.filtersConfig.routingSettings.onlyInStore,
        onlyUnRouted: this.filtersConfig.routingSettings.onlyUnRouted,
        branchId: this.filtersConfig.branchIds[0]
      },
      {reload: false, notify: false});
  }


  _getFromTo() {
    const timeWindowRef = this.filtersConfig.timeWindow;
    return {
      from: this.moment(this.filtersConfig.date).hour(timeWindowRef.fromHour).minute(timeWindowRef.fromMinute).valueOf(),
      to: this.moment(this.filtersConfig.date).hour(timeWindowRef.toHour).minute(timeWindowRef.toMinute).valueOf()
    }
  }


  private _redirectToRoutes(routeIds) {
    const fromTo = this._getFromTo();
    this.$state.go('planning-routes',
      {
        from: this.moment(fromTo.from).startOf('day').valueOf(),
        to: this.moment(fromTo.to).endOf('day').valueOf(),
        routeIds: routeIds
      });
  }


  private _redirectToBranchRoutes(routeIds) {
    const fromTo = this._getFromTo();
    this.$state.go('branch.planning.routes',
      {
        id: this.branchId,
        from: this.moment(fromTo.from).startOf('day').valueOf(),
        to: this.moment(fromTo.to).endOf('day').valueOf(),
        routeIds: routeIds
      });
  }


  private _getSegmentsForServer() {
    const segmentsCopy = angular.copy(this.segments);
    _.forEach(segmentsCopy, (segment) => {
      _.unset(segment, 'plannedServiceCounter');
    });
    return segmentsCopy;
  }


  private _getEmptyDriver() {
    return {
      supplyResourceId: null,
      name: '---',
      currentLoad: 0,
      supplyResourceProperties: {
        capacity: {
          dimensions: {
            height: undefined,
            width: undefined,
            length: undefined
          }
        }
      }
    }
  }


  private _doesAllRoutesHasDrivers() {
    return _.filter(this.segments, (s) => {
      return !!_.get(s, 'assignmentList.length', false);
    }).length
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('leanPlanningView', {
    bindings: {
      segments: '<',
      from: '<',
      to: '<',
      considerArea: '<',
      considerTimeWindows: '<',
      onlyInStore: '<',
      serviceAreaIds: '<',
      maxDeliveries: '<',
      onlyUnRouted: '<',
      openProcessIds: '<',
      branchId: '<?',
      disableBranch: '<?'
    },
    template: require('./lean-planning-view.html').default,
    controller: leanPlanningViewCtrl
  });
